export type TagState = 'none' | 'success' | 'warning' | 'critical' | 'info' | 'availabilityHighWarning' | "availabilityLowWarning";

export const toColor = (state: TagState) => {
    let color = 'slate';
    if (state === 'success') color = 'emerald'
    else if (state === 'warning') color = 'amber'
    else if (state === 'critical') color = 'rose'
    else if (state === 'info') color = 'blue'
    else if (state === 'availabilityHighWarning') color = 'amber'
    else if (state === 'availabilityLowWarning') color = 'emerald'
    return color;
}